<template>
	<div class="main2 userEdit" >
		<div class="table-form">
			<div class="form-title" v-if="$route.query.id">修改账户</div>
			<div class="form-title" v-else>新建账户</div>
			<form action="javascript:void(0)" method="post">
				<label>姓名:</label>
				<input type="text" class="nickname" name="nickname" v-model="nickname" value="" placeholder="填写姓名" />
				<div class="tipCommon"></div>
				<label>分组:</label>
				<Dropdown ref="child"  :data="data2" multiple grouped :width="580" :cbItemChanged="changed2" :cbCustomSelectedText="customSelectedText" :placeholder="'选择分组'"></Dropdown>
				<!--<input type="text" name="userAddname" id="userAddname" value="" placeholder="填写姓名" />-->
				<label >账号:</label>
				<input  type="text" class="username" name="username" v-model="username" value="" :disabled="($route.query.id)?true:false" placeholder="设置账号" />
				<div class="tipCommon" v-if="!$route.query.id"></div>
				<label >密码:</label>
				<div class = "input-col">
					<input  :type="passwordStatus?'password':'text'" class="password" name="password" v-model="password"  style="width: 78%;" disabled="" placeholder="密码" />
					<div class = "reset-btn" @click = "resetPwd">重置密码</div>
				</div>
			
				<label>权限:</label>
				<checkBox :permission="permission" @theChange="theChange"></checkBox>
				<div class="formBtn-group">
					<div class="cancel-btn" @click="goBack">取消</div>
					<input type="submit" class="submit-btn" name="submitBtn" id="submitBtn" @click="userAdd" value="提交" />
				</div>
			</form>
		</div>
		<div class="login-copyright" > © 2018 zhiyun-tech.com All rights reserved. 桂林智神信息技术有限公司 桂ICP备15010724号-1</div>
	</div>
</template>

<script>
	import Dropdown from '@/components/Dropdown'
	import checkBox from '@/components/checkBox'
	let data2 = []
	export default {
		name: 'userEdit',
		data() {
			return {
				data2: [{
					label: "",
					children: {}
				}],
				username: "",
				nickname: "",
				permission: {},
				groupIds: "",
				permissionIds: "2",
				setPermission: [2],
				oldNickname: "",
				password:"12345678",
				passwordStatus:0,
				userId:0
			}
		},
		components: {
			Dropdown,
			checkBox
		},
		created: function() {
			this.$nextTick(() => {
				this.common.get('group/showAllGroup', this.getGroup, {}, false);
				if(this.$route.query.id) {
					this.common.get('user/queryById?id=' + this.$route.query.id, this.editCreate, {}, false);
				}
				this.common.get('permission/showAllPermission', this.getPermission, {}, false);

			})
		},
		mounted: function() {},
		methods: {
			add2:function(){
				this.str++;
				console.log(432134213)
			},
			editCreate: function(data) {
				if(data != null) {
					this.oldNickname = data.nickname;
					this.nickname = data.nickname;
					this.username = data.username
					this.setPermission = data.permissions.split(",")
					this.permissionIds = this.setPermission.join("&&")
					this.data2[0].children = this.$refs.child.setData(this.data2[0].children, data.groupnames, true, "label")
					this.passwordStatus = data.status
				}
			},
			goBack: function() {
				location.href = "/userList"
			},
			getPermission: function(data) {
				this.permission = data
				let _this = this;
				if(data != null) {
					for(let a = 0; a < _this.permission.length; a++) {
						for(let i = 0; i < _this.setPermission.length; i++) {
							if(_this.permission[a].id == _this.setPermission[i]) {
								_this.permission[a].checked = true;
								break
							} else {
								_this.permission[a].checked = false;
							}
						}
					}
				}
			},
			getGroup: function(data) {
				if(data != null) {
					this.data2 = this.$refs.child.renderData("groupname", data, "分组");
				}
			},
			resetPwd:function(){
				this.layer.confirm("确定要重置密码吗？",()=>{
					this.common.get("user/resetPassword",()=>{
						layer.closeAll()
						this.passwordStatus=0
					},{id:this.$route.query.id})
				})
				
			},
			userAdd: function() {
				let params = {}
				let _this = this;
				if(this.nickname == "") {
					this.layer.alert("请输入姓名");
					return;
				}
				if(this.groupIds == "") {
					this.layer.alert("请选择分组");
					return;
				}
				if(!this.$route.query.id) {
					if((this.username == "")) {
						this.layer.alert("请输入账号");
						return;
					}
					if(this.username == "admin") {
						this.layer.alert("不可创建admin账户")
						return;
					}

					let validatorUsername = true;
					this.common.get("user/validatorUsername", function(res) {
						if(res.errcode != 0) {
							_this.common.newTip($(".username"), res.errmsg);
							validatorUsername = false;
						}
					}, {
						username: this.username
					}, false)
					if(validatorUsername == false) {
						return false;
					}
					let validatorNickname = true;
					this.common.get("user/validatorNickname", function(res) {
						if(res.errcode != 0) {
							_this.common.newTip($(".nickname"), res.errmsg);
							validatorNickname = false;
						}
					}, {
						nickname: this.nickname
					}, false)
					if(validatorNickname == false) {
						return false;
					}
				} else {
					if(this.nickname != this.oldNickname) {
						let validatorNickname = true;
						this.common.get("user/validatorNickname", function(res) {
							if(res.errcode != 0) {
								_this.common.newTip($(".nickname"), res.errmsg);
								validatorNickname = false;
							}
						}, {
							nickname: this.nickname
						}, false)
						if(validatorNickname == false) {
							return false;
						}
					}
				}

				
				let permissionPass = false;
				this.permissionIds.split("&&").forEach(function(k, index) {
					if(k == 2) {
						permissionPass = true;
						return;
					}
				})
				if(!permissionPass) {
					return this.layer.alert("权限查看内容为必选");
				}
				params.id = this.$route.query.id
				if(!this.$route.query.id) {
					params.id = this.getLocalUser.id
					params.username = this.username
				}
				params.nickname = this.nickname
				params.groupIds = this.groupIds
				params.permissionIds = this.permissionIds
				if(!this.$route.query.id) {
					this.common.post('user/addUser', this.userAddResult, params, false);
				} else {
					this.common.post('user/editUser', this.userAddResult, params, false);
				}
			},
			theChange: function(data) {
				this.permissionIds = data;
			},
			userAddResult: function(data) {
				this.layer.alert("成功", function() {
					location.href = "/userList"
				})
			},
			changed1(selected) {},
			changed2(item) {
				//				if(item.label !== 'All') return
				//				let copy = JSON.parse(JSON.stringify(data1))
				//				copy.forEach(d => !d.disabled && (d.selected = item.selected))
				//				this.data1 = copy
			},
			customSelectedText(selected, defaultFn) {
				let hasAll = false
				selected.every((s) => {
					if(s.label === 'All') {
						hasAll = true
						return false
					}
					return true
				})
				if(hasAll) {
					return 'All'
				}
				this.groupIds = selected.map((e) => e.value).join("&&");
				return defaultFn(selected)
			}
		}

	}
</script>

<style>
	@import url("../../static/bower_components/Font-Awesome/css/font-awesome.css");
	@import url("../../static/css/editForm.css");
</style>


// WEBPACK FOOTER //
// src/assets/userEdit.vue